import { EventPromoLine } from "@faire/retailer-visitor-shared/components/Events/shared/EventPromoLine";
import { IBrandPromo } from "@faire/web-api--source/indigofair/data/IBrandPromo";
import * as React from "react";

export type IMarketPromo = Pick<
  IBrandPromo,
  | "code"
  | "token"
  | "discount_bps"
  | "free_shipping"
  | "minimum_amount"
  | "ship_availability"
  | "promotional_event_type"
>;

interface IProps {
  promotion: string;
}

export const MarketPromoLine: React.FC<IProps> = ({ promotion }) => {
  return <EventPromoLine text={promotion} fullWidth mediumText />;
};
